/**
 * `holeScores` may be reordered (e.g. shotgun start) so array index !== hole number - 1.
 * UI updates match by `holeNumber`; persistence must use the same array index Mongo expects.
 */
export function resolveHoleScoreArrayIndex(
    holeScores: any[] | undefined,
    holeNumber: number
): number {
    if (!Array.isArray(holeScores) || holeScores.length === 0) {
        return Math.max(0, holeNumber - 1);
    }
    const idx = holeScores.findIndex((h: any) => Number(h?.holeNumber) === Number(holeNumber));
    return idx >= 0 ? idx : Math.max(0, holeNumber - 1);
}
